import { API } from '../../constants';
import request from '../axios';
import { success, error } from '../notification';
import { getFormData } from '../formUtils';

export const getEarnedCertifications = async () => {
    try {
        const res = await request.get(API.EARNED_CERTIFICATIONS);
        return res.data;
    } catch (e) {
        error('Errore', 'Caricamento fallito');
        throw e;
    }
}

export const createEarnedCertification = async (data) => {
    const formData = getFormData(data);   
    try {
        const res = await request.post(API.EARNED_CERTIFICATIONS, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
        success('Esito', 'Inserimento riuscito');
        return res.data;
    } catch (e) {
        error('Errore', 'Inserimento fallito');
        throw e;
    }
}

export const updateEarnedCertification = async (id, data) => {
    const formData = getFormData(data);   
    try {
        const res = await request.put(`${API.EARNED_CERTIFICATIONS}${id}/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
        success('Esito', 'Aggiornamento riuscito');
        return res.data;
    } catch (e) {
        error('Errore', 'Aggiornamento fallito');
        throw e;
    }
}

export const deleteEarnedCertification = async (id) => {
    try {
        await request.delete(`${API.EARNED_CERTIFICATIONS}${id}/`);
        success('Esito', 'Cancellazione avvenuta con successo');
    } catch (e) {
        error('Errore', 'Cancellazione fallita');
        throw e;
    }
}